import styled from 'styled-components'

const BlogIndividualStyle = styled.div`
	--relatedWidth: 32.3%;
	--descWidth: calc(100% - var(--relatedWidth));
	--lastSectionPadLeft: var(--sp26x);
	--lastSectionPadRight: var(--sp26-5x);

	padding-left: var(--lastSectionPadLeft);
	padding-right: var(--lastSectionPadRight);

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeM}) {
		--relatedWidth: 34.2%;
		--lastSectionPadLeft: var(--sp19-5x);
		--lastSectionPadRight: var(--sp19-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeS}) {
		--relatedWidth: 28.8%;
		--lastSectionPadLeft: var(--sp14x);
		--lastSectionPadRight: var(--sp14-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.DesktopSizeXS}) {
		--relatedWidth: 28.7%;
		--lastSectionPadLeft: var(--sp10x);
		--lastSectionPadRight: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.LaptopSize}) {
		display: block;
		--relatedWidth: 100%;
		--descWidth: var(--relatedWidth);
		--lastSectionPadLeft: var(--sp9x);
		--lastSectionPadRight: var(--sp9x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.LaptopSizeMin}) and (min-width: ${(props) =>
			props.theme.mediaQuery.TabletSize}) {
		display: block;
		--relatedWidth: 100%;
		--descWidth: var(--relatedWidth);
		--lastSectionPadLeft: var(--sp4-5x);
		--lastSectionPadRight: var(--sp4-5x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) {
		display: block;
		--relatedWidth: 100%;
		--descWidth: var(--relatedWidth);
		--descWidth: var(--relatedWidth);
		--lastSectionPadLeft: var(--sp2x);
		--lastSectionPadRight: var(--sp2x);
	}
`
export default BlogIndividualStyle
